<div
    [ngClass]="{
        'sidenav-title': commonQuestionnaireService.createMode,
        'sidenav-title-client': !commonQuestionnaireService.createMode
    }"
>
    <div class="fl sidenav-title-overview">
        Overview {{ commonQuestionnaireService.reviewMode ? ' - ' + commonQuestionnaireService.reviewCompanyName : '' }}
    </div>
    @if (commonQuestionnaireService.createMode && !commonQuestionnaireService.reviewMode) {
    <div class="fr add-question-div">
        <button style="all: unset">
            <span
                (click)="changePanelOpenDisplay()"
                class="fs-25 p-2 ds-icon-add"
            ></span>
        </button>
    </div>
    @if (panelOpenState) {
    <mat-accordion
        class="example-headers-align"
        multi
    >
        <mat-expansion-panel
            (focusout)="changePanelOpenDisplay()"
            id="cq-create-options"
            tabindex="-1"
            class="width-200 m-t-40"
            (opened)="onOpenedPanel($event)"
            [expanded]="panelOpenState"
            hideToggle="true"
        >
            @for (option of createOptions; track option) {
            <div
                class="p-7 create-option"
                (click)="onCreateOption({ name: option.value })"
            >
                {{ option.displayTitle }}
            </div>
            }
        </mat-expansion-panel>
    </mat-accordion>
    } }
</div>

@if (!commonQuestionnaireService.createMode) {
<div class="sidenav-switch-mode d-flex-center height-32 m-t-10 unselectable">
    <mat-slide-toggle
        (toggleChange)="switchVersion()"
        [checked]="!fullVersion"
        [disabled]="!customerQuestionnaireService.atLeastOneCondensedQuestion()"
        color="primary"
    >
        Condensed version
    </mat-slide-toggle>
</div>
} @if (commonQuestionnaireService.reviewMode && customerQuestionnaireService.sectionsLoading) {
<div [ngClass]="{ 'm-t-80': commonQuestionnaireService.createMode, 'm-t-20': commonQuestionnaireService.reviewMode }">
    <app-mdr-loader
        class="center-loader w-40-percent widget-empty"
        [rows]="8"
        [columns]="1"
    ></app-mdr-loader>
</div>
} @if (sections && sections.length && !customerQuestionnaireService.sectionsLoading) {
<div
    class="sidenav-questions fs-12 w-100 d-flex-center m-t-20"
    [ngClass]="{ 'p-t-5': !commonQuestionnaireService.createMode }"
    cdkDropListGroup
>
    <mat-accordion [multi]="true">
        @for (section of filterSections(sections); track section; let sectionIndex = $index) {
        <mat-expansion-panel
            style="margin: 0"
            class="section-{{ section.id }}"
            (opened)="sectionOpened(section)"
            [expanded]="section.isExpanded"
        >
            <mat-expansion-panel-header class="sidenav-panel-header section-panel-header disable-ripple h-100">
                <mat-panel-title
                    (click)="commonQuestionnaireService.createMode && selectSection(section); $event.stopPropagation()"
                    class="sidenav-questions-section-title fs-12 justify-space-between align-center p-em-top-1 p-em-bottom-1"
                >
                    {{ section.section ? section.section : 'Section ' + section.number }}
                    @if (!commonQuestionnaireService.createMode && !commonQuestionnaireService.reviewMode &&
                    sectionsHasAtLeastOneReview[section.number - 1]) {
                    <span class="ds-icon-validation_error warning-icon fs-26"></span>
                    } @if (commonQuestionnaireService.reviewMode && sectionsHasAtLeastOneAnsweredReview[section.number - 1]) {
                    <span class="ds-icon-validation_error warning-icon fs-26"></span>
                    }
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div
                class="drop-list"
                cdkDropList
                (cdkDropListDropped)="drop($event, section.number - 1)"
            >
                @for (question of filterQuestions(section.questions); track question; let questionIndex = $index) {
                <div
                    class="d-flex-center question-in-section-{{ section.number - 1 }}
                        justify-space-between sidenav-section-question fs-12 p-r-10"
                    id="question-{{ question.id }}"
                    (click)="selectQuestion(question, section)"
                    [ngClass]="{
                        'd-flex': question.body.answered,
                        'create-question-template': commonQuestionnaireService.createMode,
                        'customer-question-template p-l-24': !commonQuestionnaireService.createMode
                    }"
                >
                    <div
                        cdkDrag
                        [cdkDragDisabled]="
                            !commonQuestionnaireService.createMode ||
                            (cstQuestionnaireService.currentQuestionForm && !cstQuestionnaireService.currentQuestionForm.group.valid)
                        "
                        (cdkDragReleased)="setDraggedItem(question, section.number - 1, questionIndex)"
                        class="full-width"
                        [ngClass]="{ 'width-p-90': question.body.answered, 'd-flex-center': commonQuestionnaireService.createMode }"
                    >
                        @if (commonQuestionnaireService.createMode) {
                        <mat-icon
                            [ngClass]="{
                                'd-none':
                                    commonQuestionnaireService.createMode &&
                                    (!cstQuestionnaireService.currentQuestionForm ||
                                        (cstQuestionnaireService.currentQuestionForm &&
                                            cstQuestionnaireService.currentQuestionForm.group.valid))
                            }"
                            class="fs-16 drag-icon"
                            cdkDragHandle
                        >
                            drag_indicator
                        </mat-icon>
                        } @if (commonQuestionnaireService.createMode) {
                        <div
                            class="color-icon width-p-16 height-20 text-center fs-18 p-5 d-flex space-between"
                            [ngStyle]="{ 'background-color': getBackgroundForQuestionType(question.type_id) }"
                        >
                            <span class="{{ mapQuestionToIcon(question.type_id) }} fs-20"></span>
                            <span class="fs-14 m-r-5">
                                {{ cstQuestionnaireService.getQuestionNumber(question, section.number - 1) }}
                            </span>
                        </div>
                        } @if (commonQuestionnaireService.createMode) {
                        <div class="create-question-title p-t-6 p-b-6 text-ellipsis">
                            {{ question.title }}
                        </div>
                        } @if (!commonQuestionnaireService.createMode) {
                        <p
                            class="text-ellipsis question-title p-t-6 p-b-6"
                            (click)="selectQuestionFromSidenav(question, section)"
                        >
                            <span>{{ question.number + 1 }}</span>
                            <span [ngClass]="{ required: question.required && customerQuestionnaireService.displayVersion === 'full' }">
                                {{ '. ' + question.title }}</span
                            >
                        </p>
                        }
                    </div>
                    <div class="question-icon d-flex">
                        @if (commonQuestionnaireService.showCheckMark(question)) {
                        <span class="ds-icon-validation checked-icon fs-24"> </span>
                        } @if (commonQuestionnaireService.reviewMode && commonQuestionnaireService.showPendingMark(question)) {
                        <span class="ds-icon-pending pending-icon fs-24"> </span>
                        } @if (!commonQuestionnaireService.reviewMode && !commonQuestionnaireService.createMode &&
                        commonQuestionnaireService.showReviewWarningMark(question)) {
                        <span class="fs-26 ds-icon-validation_error warning-icon"> </span>
                        } @if (commonQuestionnaireService.reviewMode && cstQuestionnaireService.isQuestionAnsweredAfterReview(question)) {
                        <span class="fs-26 ds-icon-validation_error warning-icon"> </span>
                        }
                    </div>
                </div>
                }
            </div>
        </mat-expansion-panel>
        }
    </mat-accordion>
</div>
}
